import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { buildMyPropertiesDnaRedirectPath } from "../utils/clientMyPropertiesTabs";

/**
 * CL-372A: Legacy /client-portal/account/my-property → My Properties DNA tab.
 */
export default function ClientMyPropertyLegacyRedirect() {
  const { search } = useLocation();
  const target = buildMyPropertiesDnaRedirectPath(search);

  return (
    <div className="mx-auto max-w-lg px-4 py-10 space-y-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Redirecting…</p>
      <h1 className="text-lg font-semibold text-slate-900">Property DNA moved to My Properties</h1>
      <p className="text-sm text-slate-600">
        Calgary assessment, permits, and community context now live under{" "}
        <span className="font-medium text-slate-800">Real Estate → My Properties</span> on the Property DNA tab.
      </p>
      <Link to={target} className="inline-block text-sm font-medium text-slate-900 underline">
        Continue to My Properties
      </Link>
      <Navigate to={target} replace />
    </div>
  );
}
